import { render, staticRenderFns } from "./ZigBeeMultiControlSwitch.vue?vue&type=template&id=072ea14a&scoped=true&"
import script from "./ZigBeeMultiControlSwitch.vue?vue&type=script&lang=js&"
export * from "./ZigBeeMultiControlSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ZigBeeMultiControlSwitch.vue?vue&type=style&index=0&id=072ea14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072ea14a",
  null
  
)

export default component.exports